export default [
  {
    image:
      "https://www.fegreppa.es/wp-content/uploads/2025/04/contratos-laborales-panaderia-1024x683.jpg",
    name: "Asesoria legal Laboral",
    route: "/pages/landing-pages/about-us",
  },
  {
    image: `https://media.tiempodesanjuan.com/p/669a9abcbb83ff17f7d0a34470d807cf/adjuntos/331/imagenes/000/726/0000726420/1200x630/smart/rivadaviajpg.jpg`,
    name: "Camping temporada 2026",
    route: "/pages/landing-pages/contact-us",
  },
  {
    image:
      "https://noticias.santacruz.gob.ar/media/k2/items/cache/8847e79c059c45a1cd15376d6b260e41_XL.jpg",
    name: "Capacitacion pasteleros",
    route: "/pages/authentication/sign-in",
  },
  {
    image: `https://media.istockphoto.com/id/696978118/es/foto/panadero.jpg?s=612x612&w=0&k=20&c=817m6LTshZaLUXfVCYuzgTY_3j9zpDPW7hSiEZRR5X0=`,
    name: "Congreso - Derechos de la mujer en el trabajo",
    route: "/pages/landing-pages/author",
  },
];
